import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken} from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import {  jumpToFamily } from 'src/helper/webviewFun'
import forbidScroll from 'src/tools/forbidScroll'

import CD from '../../../component/CountDown'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.familyStore = this.props.store.register('activity/family')
  }

  state = {
    lang: langM.ar,
    isShowRule: false,
    tabState: 2,
    language:'en',
    cd: 0,
    rankList: [],
    top1: {},
    top2: {},
    top3: {},
    myRank: {}
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    if (language =='tr') {
      setDocumentTitle('Klan')
    }else{
      setDocumentTitle('Family')
    }

    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.familyStore.GetUserInfoWeb(uid)
    console.log(uid, 'uid')
    await this.RunOnStart(uid)
    let cd = await this.familyStore.getCd()
    let list = await this.familyStore.getRank()
    console.log(list)
    this.setState({
      cd: cd,
      rankList: list && list.list,
      top1: list && list.list[0],
      top2: list && list.list[1],
      top3: list && list.list[2],
      myRank: list && list.myFamilyRank
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
  }

  componentDidMount() {

  }

  onChangeRule(state) {
    forbidScroll(state)
    this.setState({
      isShowRule: state
    })
  }

  onChangeTab(state) {
    this.setState({
      tabState: state
    })
  }

  headComp(img, head, name, id, gold, fId) {
    return (
      <div className="head-wrap">
        <div className="head-border">
          <div className="head-wear"
            onClick={() => jumpToFamily(fId)}
            style={{ backgroundImage: `url(${head})` }}></div>
          <div className="head-ava">
            <img src={img} alt="" />
          </div>
          <div className="head-info">
            <div className='name'>{name}</div>
            <div className='id'>ID:{id}</div>
            <div className='gold'>{score(gold)}</div>
          </div>
        </div>
      </div>
    )
  }

  userItemComp(index, rank, img, name, id, gold, fId) {
    return (
      <div className="user-item" key={index}>
        <div className="rank">{rank}</div>
        <div className="ava" onClick={() => jumpToFamily(fId)}>
          <div className="six"></div>
          <div className="ava-box1">
            <div className="ava-box2">
              <div className="ava-box3">
                <img src={img} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="info">
          <div className="name">{name}</div>
          <div className="id">ID:{id}</div>
        </div>
        <div className="gold-img">
          <img src="/img/gold.png" alt="" />
          <div className="gold">{score(gold)}</div>
        </div>
      </div>
    )
  }

  tdasds() {
    let timeComp = ({ langtxt, daytxt, day, hour, mi, se }) => {
      return (
        <div className="timer">
          <div className="d time-box">
            {day}
          </div>
          <div style={{ fontSize: "0.24rem" }}>
            {(this.state.language =='tr'?"Gün":this.state.language =='ar'?"يوم":'day')}
          </div>
          <div className="h time-box">
            {hour}
          </div>
          <div>
            :
          </div>
          <div className="m time-box">
            {mi}
          </div>
          <div>
            :
          </div>
          <div className="s time-box">
            {se}
          </div>
        </div>
      )
    }
    let rwList = [
      {
        title: {en:"Top1", tr:'İlk 1',ar:"Top1"},
        list: [
          {
            title: this.state.lang.t1,
            list: [
              {
                img: "https://img.chatie.live/app/noble/king.png",
                name: {en:"VIP5 (14days)",tr:"VIP5 (14 Gün)",ar:'VIP5 (14days)'}
              },
              {
                img: "/img/activity/family/rw/m1.png",
                name: {en:"Medal (30days)",tr:"Madalya (30 Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c1.png",
                name: {en:"Car (30days)",tr:"Araç (30 Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h1.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30 Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (30k)",tr:"Altın (30K)",ar:'Gold (30k)'}
              },
            ]
          },
          {
            title: this.state.lang.t2,
            list: [
              {
                img: "https://img.chatie.live/app/noble/king.png",
                name: {en:"VIP5 (7days)",tr:"VIP5 (7 Gün)",ar:'VIP5 (7days)'}
              },
              {
                img: "/img/activity/family/rw/m1.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c1.png",
                name: {en:"Car (30days)",tr:"Araç (30Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h1.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (10k)",tr:"Altın (10K)",ar:'Gold (10k)'}
              },
            ]
          },
          {
            title: this.state.lang.t3,
            list: [
              {
                img: "/img/activity/family/rw/h1.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
            ]
          },
        ]
      },
      {
        title: {en:"Top2", tr:'İlk 2',ar:"Top2"},
        list: [
          {
            title: this.state.lang.t1,
            list: [
              {
                img: "https://d12o7ht18lg4ku.cloudfront.net/app/noble/duke.png",
                name: {en:"VIP4 (14days)",tr:"VIP4 (14Gün)",ar:'VIP4 (14days)'}
              },
              {
                img: "/img/activity/family/rw/m2.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c2.png",
                name: {en:"Car (30days)",tr:"Araç (30Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h2.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (20k)",tr:"Altın (20K)",ar:'Gold (20k)'}
              },
            ]
          },
          {
            title: this.state.lang.t2,
            list: [
              {
                img: "https://d12o7ht18lg4ku.cloudfront.net/app/noble/duke.png",
                name: {en:"VIP4 (7days)",tr:"VIP4 (7Gün)",ar:'VIP4 (7days)'}
              },
              {
                img: "/img/activity/family/rw/m2.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c2.png",
                name: {en:"Car (30days)",tr:"Araç (30Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h2.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (8k)",tr:"Altın (8K)",ar:'Gold (8k)'}
              },
            ]
          },
          {
            title: this.state.lang.t3,
            list: [
              {
                img: "/img/activity/family/rw/h2.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
            ]
          },
        ]
      },
      {
        title: {en:"Top3", tr:'İlk 3',ar:"Top3"},
        list: [
          {
            title: this.state.lang.t1,
            list: [
              {
                img: "https://d12o7ht18lg4ku.cloudfront.net/app/noble/marquis.png",
                name: {en:"VIP3 (14days)",tr:"VIP3 (14Gün)",ar:'VIP3 (14days)'}
              },
              {
                img: "/img/activity/family/rw/m3.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c3.png",
                name: {en:"Car (30days)",tr:"Araç (30Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h3.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (10k)",tr:"Altın (10K)",ar:'Gold (10k)'}
              },
            ]
          },
          {
            title: this.state.lang.t2,
            list: [
              {
                img: "https://img.chatie.live/app/noble/marquis.png",
                name: {en:"VIP3 (7days)",tr:"VIP3 (7Gün)",ar:'VIP3 (7days)'}
              },
              {
                img: "/img/activity/family/rw/m3.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/c3.png",
                name: {en:"Car (30days)",tr:"Araç (30Gün)",ar:'Car (30days)'}
              },
              {
                img: "/img/activity/family/rw/h3.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
              {
                img: "/img/gold.png",
                name: {en:"Gold (5k)",tr:"Altın (5K)",ar:'Gold (5k)'}
              },
            ]
          },
          {
            title: this.state.lang.t3,
            list: [
              {
                img: "/img/activity/family/rw/h3.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              },
            ]
          },
        ]
      },
      {
        title: {en:"Top4-Top10", tr:"İlk 4-10",ar:"Top4-Top10"},
        list: [
          {
            title: this.state.lang.t2,
            list: [
              {
                img: "/img/activity/family/rw/m4.png",
                name: {en:"Medal (30days)",tr:"Madalya (30Gün)",ar:'Medal (30days)'}
              },
              {
                img: "/img/activity/family/rw/h4.png",
                name: {en:"Head (30days)",tr:"Çerçeve (30Gün)",ar:'Head (30days)'}
              }
            ]
          }
        ]
      },
    ]
    let { language } = this.state
    console.log(language)
    return (
      <div className={`family-main-wrap ${this.state.language == 'ar' ? "ar-style" : ""}`}>

        {/* 规则 */}
        <div className={`family-rule`}
          onClick={() => this.onChangeRule(false)}
          style={{ display: `${this.state.isShowRule ? "block" : "none"}` }}>
          <div className="mask"></div>
          <div className={`rule-wrap ${this.state.isShowRule ? "family-rule-active" : ""}`} >
            <div className="title">{this.state.lang.rule}</div>
            <div className="content" dangerouslySetInnerHTML={{ __html: this.state.lang.ruleC }}>
            </div>
          </div>
        </div>

        {/* 头部 */}
        <div className="family-banner">
          <div className="fire"></div>
          <div className="fire2"></div>
          <div className="cd-title">{this.state.lang.acd}</div>
          <CD leftTimestamp={this.state.cd} slot={timeComp} />
          <div className="rule-btn" onClick={() => this.onChangeRule(true)}>
            <span>{this.state.lang.rule}</span>
          </div>
        </div>

        {/* 选项卡 */}
        <div className="family-tab">
          <div
            onClick={() => this.onChangeTab(1)}
            className={`family-tab-reward ${this.state.tabState == 1 ? "family-active" : ""}`}>
            {this.state.lang.reward}
          </div>
          <div
            onClick={() => this.onChangeTab(2)}
            className={`family-tab-rank ${this.state.tabState == 2 ? "family-active" : ""}`}>
            {this.state.lang.rank}
          </div>
        </div>

        {/* 奖励 */}
        <div className="family-content-reward" style={{ display: `${this.state.tabState == 1 ? "block" : "none"}` }}>
          {
            rwList.map((item, index) => {
              return (
                <div className="reward-item" key={index}>
                  <div className="top"></div>
                  <div className="title">{item.title[language]?item.title[language]:item.title['en']}</div>
                  <div className="center">
                    {
                      item.list.map((item2, index) => {
                        return (
                          <div className="reward-item-inner">
                            <div className="rw-title">
                              <div className="r-l"></div>
                              <div className="r-c">{item2.title}</div>
                              <div className="r-r"></div>
                            </div>
                            <div className="rw-content">
                              {
                                item2.list.map((item2, index2) => {
                                  return (
                                    <div className="rw-item" key={index2}>
                                      <div className="rw-img">
                                        <img src={item2.img} style={{ transform: `scale(${item2.img.includes("gold") && "0.8"})` }} alt="" />
                                      </div>
                                      <div className="rw-name">{item2.name[language]?item2.name[language]:item2.name['en']}</div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="bottom"></div>
                </div>
              )
            })
          }

        </div>

        {/* 排名 */}
        <div className="family-content-rank" style={{ display: `${this.state.tabState == 2 ? "block" : "none"}` }}>

          <div className="top">
            <div className="light"></div>
            <div className="light2"></div>
            <div className="top1">
              {this.headComp(
                this.state.top1 && this.state.top1.icon,
                "/img/activity/family/h1.png",
                this.state.top1 && this.state.top1.name,
                this.state.top1 && this.state.top1.sfid,
                this.state.top1 && this.state.top1.point,
                this.state.top1 && this.state.top1.familyId
              )}
            </div>

            <div className="top23">
              <div className="top2">
                {this.headComp(
                  this.state.top2 && this.state.top2.icon,
                  "/img/activity/family/h2.png",
                  this.state.top2 && this.state.top2.name,
                  this.state.top2 && this.state.top2.sfid,
                  this.state.top2 && this.state.top2.point,
                  this.state.top2 && this.state.top2.familyId
                )}
              </div>
              <div className="top3">
                {this.headComp(
                  this.state.top3 && this.state.top3.icon,
                  "/img/activity/family/h3.png",
                  this.state.top3 && this.state.top3.name,
                  this.state.top3 && this.state.top3.sfid,
                  this.state.top3 && this.state.top3.point,
                  this.state.top3 && this.state.top3.familyId
                )}
              </div>
            </div>

          </div>

          <div className="center">
            {/* 参数顺序： index, rank, img, name, id, gold, uid */}
            {
              this.state.rankList && this.state.rankList.map((item, index) => {
                if (index > 2) {
                  return (
                    this.userItemComp(
                      index,
                      item.rank,
                      item.icon,
                      item.name,
                      item.sfid,
                      item.point,
                      item.familyId
                    )
                  )
                }
              })
            }
          </div>
          <div className="bottom"></div>
        </div>

        <div className="my-rank" style={{ display: `${this.state.tabState == 2 ? "flex" : "none"}` }}>
          <div className="rank">{this.state.myRank && this.state.myRank.rank}</div>
          <div className="ava" onClick={() => jumpToFamily(this.state.myRank && this.state.myRank.familyId)}>
            <div className="six"></div>
            <div className="ava-box1">
              <div className="ava-box2">
                <div className="ava-box3">
                  <img src={this.state.myRank && this.state.myRank.icon} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="info">
            <div className="name">{this.state.myRank && this.state.myRank.name}</div>
            <div className="id">ID:{this.state.myRank && this.state.myRank.sfid}</div>
          </div>
          <div className="gold-img">
            <img src="/img/gold.png" alt="" />
          </div>
          <div className="gold">{this.state.myRank && this.state.myRank.point || 0}</div>
        </div>

        <div className="src" style={{ display: "none" }}>
          <img src="/img/activity/family/rule_bg.png" alt="" />
          <img src="/img/activity/family/t.png" alt="" />
          <img src="/img/activity/family/c.png" alt="" />
          <img src="/img/activity/family/b.png" alt="" />
          <img src="/img/activity/family/l.png" alt="" />
          <img src="/img/activity/family/r.png" alt="" />
          <img src="/img/activity/family/gift.png" alt="" />
        </div>

      </div>
    )
  }

  render(){
    return <div style={{width:'7.5rem', margin:'1rem auto',fontSize:'0.32rem',textAlign:'center'}}>{this.state.lang.tips}</div>
  }
}


// WEBPACK FOOTER //
// src/pages/activity/family/index.js